import React from 'react';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { LazyIntegrationLog } from './async.tsx';

export const IntegrationLog = () => (
	<LazyPage
		Page={LazyIntegrationLog}
		pageId="async-jira-eoc-integration-automation"
		shouldShowSpinner
	/>
);
